var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-6",attrs:{"outlined":""}},[_c('v-card-text',[_c('div',{staticClass:"mt-16"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src,"frameborder":"0","allowfullscreen":""}})]),_c('p',{staticClass:"pt-3"},[_vm._v(" Für Informationen zur Anmeldung öffnen Sie die Termine. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }